export default __webpack_public_path__ + "static/media/technical-2.4bc8211f.png";